module.exports = __webpack_public_path__ + "img/i-home-black.15b9d1c7.svg";